export const THANK_YOU = "thankyou";
export const DATA_QUALITY = "dataquality";
export const OVER_QUOTA = "overquota";
export const TERMINATE = "terminate";
export const ERROR = "error";
export const INELIGIBLE = "ineligible";
export const INVALID_URL = "invalidUrl";

export const THANK_YOU_URL_PARAM = "th";
export const DATA_QUALITY_URL_PARAM = "da";
export const OVER_QUOTA_URL_PARAM = "ov";
export const TERMINATE_URL_PARAM = "te";
export const ERROR_URL_PARAM = "er";




// WEBPACK FOOTER //
// ./src/constants/feedbackCodes.js